/**
 * Collection Pagination Controller
 */

export class CollectionPagination {
    constructor(rootElement, manager) {
        this.root = rootElement || document;
        this.manager = manager;

        this.elements = {
            wrapper: this.root.querySelector('[data-collection-pagination]'),
            prevBtn: this.root.querySelector('[data-pagination-prev]'),
            nextBtn: this.root.querySelector('[data-pagination-next]'),
            currentPage: this.root.querySelector('[data-current-page]'),
            totalPages: this.root.querySelector('[data-total-pages]'),
        };

        this.init();
    }

    init() {
        this.attachEventListeners();
        this.manager.on('state:change', (state) => {
            this.render(state.pagination);
        });
    }

    attachEventListeners() {
        if (this.elements.prevBtn) {
            this.elements.prevBtn.addEventListener('click', (event) => {
                event.preventDefault();
                const state = this.manager.getState();
                const target = Math.max(1, state.pagination.page - 1);
                if (target !== state.pagination.page) {
                    this.manager.setPage(target);
                }
            });
        }

        if (this.elements.nextBtn) {
            this.elements.nextBtn.addEventListener('click', (event) => {
                event.preventDefault();
                const state = this.manager.getState();
                const target = Math.min(state.pagination.totalPages, state.pagination.page + 1);
                if (target !== state.pagination.page) {
                    this.manager.setPage(target);
                }
            });
        }
    }

    render(pagination = {}) {
        if (!this.elements.wrapper) {
            return;
        }

        const currentPage = Number(pagination.page) || 1;
        const totalPages = Number(pagination.totalPages) || 1;

        if (this.elements.currentPage) {
            this.elements.currentPage.textContent = currentPage;
        }

        if (this.elements.totalPages) {
            this.elements.totalPages.textContent = totalPages;
        }

        if (this.elements.prevBtn) {
            this.elements.prevBtn.disabled = currentPage <= 1;
        }

        if (this.elements.nextBtn) {
            this.elements.nextBtn.disabled = currentPage >= totalPages;
        }

        if (totalPages <= 1) {
            this.elements.wrapper.classList.add('hidden');
            this.elements.wrapper.classList.remove('flex');
        } else {
            this.elements.wrapper.classList.remove('hidden');
            this.elements.wrapper.classList.add('flex');
        }
    }
}

export default CollectionPagination;
